import React from 'react';
import { ConfigureCopilotModelByJobTitle } from 'apps/sigma2-ui/src/components/workflows/ConfigureCopilotModelByJobTitle';
import { ConfigureCopilotModelByJobTitleProps } from 'apps/sigma2-ui/src/components/workflows/ConfigureCopilotModelByJobTitle';
import { HiringCopilotModelByJobTitleConfig } from 'libs/end-to-end/src/types/databases/scheduling/hiring-copilot-model-by-job-title-config';

const HIRING_COPILOT_DISPLAY_NAME = 'Hiring';

export type ConfigureHiringCopilotModelByJobTitleProps = Omit<
  ConfigureCopilotModelByJobTitleProps,
  'copilotDisplayName' | 'details' | 'updateDetails'
> & {
  details: HiringCopilotModelByJobTitleConfig;
  updateDetails: (config: HiringCopilotModelByJobTitleConfig) => void;
};

export const ConfigureHiringCopilotModelByJobTitle = ({
  details,
  updateDetails,
  ...props
}: ConfigureHiringCopilotModelByJobTitleProps) => (
  <ConfigureCopilotModelByJobTitle
    copilotDisplayName={HIRING_COPILOT_DISPLAY_NAME}
    details={details}
    updateDetails={updateDetails}
    {...props}
  />
);
